import { render, staticRenderFns } from "./VisitInvitationSum.vue?vue&type=template&id=173fc7c6&scoped=true&"
import script from "./VisitInvitationSum.vue?vue&type=script&lang=js&"
export * from "./VisitInvitationSum.vue?vue&type=script&lang=js&"
import style0 from "./VisitInvitationSum.vue?vue&type=style&index=0&id=173fc7c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173fc7c6",
  null
  
)

export default component.exports